import React, { useState } from 'react';
import { Heart, Star, Send, Check } from 'lucide-react';
type Comment = {
  username: string;
  stars: number;
  text: string;
  likes: number;
  time: string;
};
const initialComments: Comment[] = [{
  username: '@marek_trener_wwa',
  stars: 5,
  text: 'Zastosowałem system planowania tygodniowego od pierwszego tygodnia. Oszczędzam ponad 10 godzin tygodniowo. Warto każdą złotówkę.',
  likes: 47,
  time: '3 godziny temu'
}, {
  username: '@tomasz_coach_krakow',
  stars: 5,
  text: 'W ciągu dwóch tygodni skróciłem czas przygotowania o 80% bez zmiany metody trenowania. Wystarczyły checklisty.',
  likes: 32,
  time: '5 godzin temu'
}, {
  username: '@rafal_trener_poznan',
  stars: 5,
  text: 'Część dotycząca raportów dla rodziców otworzyła mi oczy. Nigdy wcześniej nie miałem tak jasnego systemu komunikacji.',
  likes: 28,
  time: '8 godzin temu'
}, {
  username: '@piotr_football_gdansk',
  stars: 4,
  text: 'Materiałów jest mnóstwo. Na początku myślałem że nie wykorzystam wszystkiego — ale po uporządkowaniu każda strona ma sens.',
  likes: 19,
  time: '12 godzin temu'
}, {
  username: '@krzysztof_coach_wroclaw',
  stars: 5,
  text: 'Plan B na deszcz uratował mnie już kilka razy. Wcześniej każdy deszczowy dzień to był natychmiastowy chaos.',
  likes: 24,
  time: 'Wczoraj'
}];
const morePool: Comment[] = [{
  username: '@jakub_trener_lodz',
  stars: 5,
  text: 'Tom 5 — Atlas Trenera jest po prostu nie do ocenienia. 200+ ćwiczeń pod ręką.',
  likes: 18,
  time: '1 dzień temu'
}, {
  username: '@michal_u8_coach',
  stars: 5,
  text: 'Trenuję U8 i Tom 2 idealnie wpasował się w to czego potrzebowałem. Diagramy boiska są bardzo czytelne.',
  likes: 22,
  time: '1 dzień temu'
}, {
  username: '@lukasz_akademia',
  stars: 5,
  text: 'Pracuję w akademii i poleciłem system wszystkim trenerom u nas. Cały sztab pracuje teraz w tym samym standardzie.',
  likes: 31,
  time: '2 dni temu'
}, {
  username: '@adam_trener_szczecin',
  stars: 5,
  text: '50 komend trenera to złoto. Moja drużyna reaguje natychmiast, autorytet na boisku wzrósł od pierwszego treningu.',
  likes: 26,
  time: '2 dni temu'
}, {
  username: '@pawel_grassroots',
  stars: 4,
  text: 'Bardzo praktyczne narzędzia. Karty oceny zawodników pomogły mi rozmawiać z rodzicami konkretnie.',
  likes: 14,
  time: '2 dni temu'
}, {
  username: '@dawid_coach_lublin',
  stars: 5,
  text: 'Makroplan 40 tygodni rozwiązał mi największy problem sezonu. Wiem co robię od września do czerwca.',
  likes: 29,
  time: '3 dni temu'
}, {
  username: '@bartek_uefa_b',
  stars: 5,
  text: 'Mam licencję UEFA B i myślałem że nie znajdę tu nic nowego. Pomyliłem się — szablony są na poziomie.',
  likes: 35,
  time: '3 dni temu'
}, {
  username: '@kamil_trener_kat',
  stars: 5,
  text: 'Raport miesięczny dla rodziców to game changer. Rodzice wreszcie widzą postępy.',
  likes: 21,
  time: '3 dni temu'
}, {
  username: '@grzegorz_u11',
  stars: 4,
  text: 'Solidny materiał, zwłaszcza Tom 3 o podejmowaniu decyzji pod presją. Zawodnicy zaczęli myśleć szybciej.',
  likes: 16,
  time: '4 dni temu'
}, {
  username: '@robert_szkoleniowiec',
  stars: 5,
  text: 'Po latach pracy w klubie wreszcie mam wszystko w jednym miejscu. PDF na tablecie i wychodzę na boisko gotowy.',
  likes: 27,
  time: '4 dni temu'
}];
const StarRating = ({
  value,
  onChange,
  size = 'w-5 h-5',
  interactive = false
}: {
  value: number;
  onChange?: (v: number) => void;
  size?: string;
  interactive?: boolean;
}) => <div className="flex items-center gap-0.5" data-id="element-257">
    {[1, 2, 3, 4, 5].map(i => <button key={i} type="button" onClick={() => interactive && onChange?.(i)} disabled={!interactive} aria-label={`${i} gwiazdek`} className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'} ${i <= value ? 'text-brand-gold' : 'text-slate-300'}`} data-id="element-258">
        <Star className={`${size} ${i <= value ? 'fill-current' : ''}`} data-id="element-259" />
      </button>)}
  </div>;
export function CommentsSection() {
  const [text, setText] = useState('');
  const [name, setName] = useState('');
  const [rating, setRating] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [extraComments, setExtraComments] = useState<Comment[]>([]);
  const [likedSet, setLikedSet] = useState<Set<string>>(new Set());
  const allComments = [...initialComments, ...extraComments];
  const visible = allComments.slice(0, visibleCount);
  const canLoadMore = visibleCount < initialComments.length + morePool.length;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim() || rating === 0) return;
    setSubmitted(true);
    setText('');
    setName('');
    setRating(0);
    setTimeout(() => setSubmitted(false), 5000);
  };
  const handleLoadMore = () => {
    const start = extraComments.length;
    const next = morePool.slice(start, start + 5);
    setExtraComments([...extraComments, ...next]);
    setVisibleCount(visibleCount + 5);
  };
  const toggleLike = (username: string) => {
    setLikedSet(prev => {
      const next = new Set(prev);
      if (next.has(username)) next.delete(username);else next.add(username);
      return next;
    });
  };
  return <div className="max-w-3xl mx-auto" data-id="element-260">
      <div className="text-center mb-10" data-id="element-261">
        <h2 className="text-3xl md:text-4xl font-extrabold text-brand-navy mb-3" data-id="element-262">
          Opinie trenerów którzy już używają systemu
        </h2>
        <p className="text-brand-text-soft" data-id="element-263">
          Ponad 1 200 trenerów zmieniło już swój sposób trenowania
        </p>
      </div>

      <div className="max-w-2xl mx-auto card-soft p-6 md:p-7 mb-8 relative border border-slate-200" data-id="element-264">
        {submitted && <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/95 backdrop-blur-sm rounded-xl border-2 border-brand-green p-6" data-id="element-265">
            <div className="text-center" data-id="element-266">
              <div className="w-16 h-16 rounded-full bg-brand-green/10 border-2 border-brand-green flex items-center justify-center mx-auto mb-4" data-id="element-267">
                <Check className="w-8 h-8 text-brand-green" strokeWidth={3} data-id="element-268" />
              </div>
              <h3 className="text-xl font-extrabold text-brand-navy mb-2" data-id="element-269">
                Dziękujemy za Twoją opinię!
              </h3>
              <p className="text-brand-text-soft max-w-sm mx-auto text-sm" data-id="element-270">
                Twoja recenzja zostanie wkrótce opublikowana po moderacji.
              </p>
            </div>
          </div>}

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-271">
          <div data-id="element-272">
            <label className="block text-brand-navy font-bold mb-2 text-sm" data-id="element-273">
              Zostaw swoją opinię dla społeczności trenerów:
            </label>
            <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Napisz tutaj swoje doświadczenie z Futbol Gotowy: System 365..." rows={4} className="w-full bg-brand-light border border-slate-200 rounded-xl p-3 text-brand-text-dark placeholder-slate-400 focus:outline-none focus:border-brand-green focus:ring-2 focus:ring-brand-green/20 transition-colors resize-none text-sm" required data-id="element-274" />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" data-id="element-275">
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Twoje imię (opcjonalnie)" className="flex-1 bg-brand-light border border-slate-200 rounded-xl px-3 py-2.5 text-brand-text-dark placeholder-slate-400 focus:outline-none focus:border-brand-green focus:ring-2 focus:ring-brand-green/20 transition-colors text-sm" data-id="element-276" />
            <div className="flex items-center gap-3" data-id="element-277">
              <span className="text-brand-text-soft text-sm font-medium" data-id="element-278">
                Oceń:
              </span>
              <StarRating value={rating} onChange={setRating} interactive size="w-6 h-6" data-id="element-279" />
            </div>
          </div>

          <button type="submit" disabled={!text.trim() || rating === 0} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl bg-brand-green hover:bg-brand-green-dark text-white font-extrabold uppercase tracking-wider text-sm transition-all duration-200 hover:-translate-y-0.5 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:translate-y-0 shadow-cta" data-id="element-280">
            <Send className="w-4 h-4" data-id="element-281" />
            Opublikuj
          </button>
        </form>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-282">
        {visible.map((c, i) => {
        const liked = likedSet.has(c.username);
        const likeCount = c.likes + (liked ? 1 : 0);
        return <div key={`${c.username}-${i}`} className="card-soft p-5 md:p-6 border border-slate-200" data-id="element-283">
              <div className="flex items-start justify-between gap-3 mb-2" data-id="element-284">
                <div className="flex items-center gap-3 min-w-0" data-id="element-285">
                  <div className="w-10 h-10 rounded-full bg-brand-navy flex items-center justify-center text-white font-extrabold shrink-0" data-id="element-286">
                    {c.username.charAt(1).toUpperCase()}
                  </div>
                  <span className="text-brand-green font-extrabold truncate" data-id="element-287">
                    {c.username}
                  </span>
                </div>
                <StarRating value={c.stars} size="w-4 h-4" data-id="element-288" />
              </div>

              <p className="text-brand-text-dark leading-relaxed mb-3 text-[15px]" data-id="element-289">
                {c.text}
              </p>

              <div className="flex items-center gap-5 text-sm" data-id="element-290">
                <button onClick={() => toggleLike(c.username)} className={`flex items-center gap-1.5 transition-colors ${liked ? 'text-brand-danger' : 'text-brand-text-soft hover:text-brand-text-dark'}`} aria-label={liked ? 'Usuń polubienie' : 'Polub'} data-id="element-291">
                  <Heart className={`w-4 h-4 ${liked ? 'fill-current' : ''}`} data-id="element-292" />
                  <span className="font-medium" data-id="element-293">{likeCount} Polubień</span>
                </button>
                <span className="text-brand-text-soft" data-id="element-294">{c.time}</span>
              </div>
            </div>;
      })}

        {canLoadMore && <div className="flex justify-center pt-4" data-id="element-295">
            <button onClick={handleLoadMore} className="btn-outline" data-id="element-296">
              Załaduj 5 kolejnych opinii
            </button>
          </div>}
      </div>
    </div>;
}